import React from 'react'
import PropTypes from 'prop-types'
import './toggle.css'

class Toggle extends React.Component {

    constructor(props) {
        super(props)
        this.state = {state: this.props.on ? true : false}
    }

    handleClick(e) {
        this.setState({
            state: !this.state.state
        }, () => {
            if (this.props.onChange) this.props.onChange(this.state.state)
        })        
    }

    render() {
        return(
            <div className={`toggle__wrapper toggle__wrapper--${this.state.state ? 'on' : 'off'} ${this.props.className}`} onClick={this.handleClick.bind(this)}>
                <div className='toggle'>
                    <div className='toggle__background'/>
                    <div className='toggle__nib'/>
                </div>
            </div>
        )
    }    

}

Toggle.propTypes = {
    states: PropTypes.array,
    children: PropTypes.array,
    on: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    className: PropTypes.string
}

export default Toggle